export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-accent-100/80 text-accent-700 text-xs font-semibold mb-6">
              <i className="ri-fire-line text-sm"></i>
              <span>2026暑期档热映中</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 font-heading leading-tight mb-5">
              蓝莓影院<span className="text-primary-500"> · </span>你的免费高清观影首选
            </h1>

            <p className="text-base md:text-lg text-foreground-500 font-heading italic mb-4">
              不缓冲，不收费，每日更新，好片不断
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-8">
              蓝莓影院是面向全球华语影迷的免费在线观影平台。我们精心收录超过两万部各国影片，
              涵盖最新上映的热门大片、影史经典名作、独立电影节获奖作品和优质纪录片。
              每日更新五十余部高清电影，采用智能预加载和全球CDN加速技术，无论何时何地都能享受不缓冲的流畅观影体验。
              这个暑期，我们从科幻巨制到温馨动画，从悬疑烧脑到爆笑喜剧，陪你度过每一个值得被电影点亮的夜晚。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-extrabold text-accent-500 font-heading">20000+</div>
                <div className="text-xs text-foreground-500 mt-1">累计片库</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-extrabold text-accent-500 font-heading">50+</div>
                <div className="text-xs text-foreground-500 mt-1">日均更新/部</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-extrabold text-accent-500 font-heading">1080P</div>
                <div className="text-xs text-foreground-500 mt-1">高清画质</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-play-circle-line text-base"></i>
                开始观影
              </a>
              <a
                href="#about"
                className="px-8 py-3.5 rounded-lg border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-information-line text-base"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/40 to-accent-200/30 rounded-2xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20warm%20golden%20film%20projector%20beam%20illuminating%20floating%20dust%20particles%20in%20dark%20theater%2C%20film%20strip%20flowing%20elegantly%2C%20rich%20amber%20and%20deep%20red%20tones%2C%20atmospheric%20cinema%20aesthetic%2C%20soft%20dramatic%20lighting%2C%20artistic%20composition%2C%20movie%20magic%20mood&width=700&height=500&seq=hero-main&orientation=landscape"
                alt="蓝莓影院 · 电影世界"
                className="relative rounded-xl w-full h-auto object-cover"
                width="700"
                height="500"
                title="蓝莓影院 · 电影世界"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}